module.exports = __webpack_public_path__ + "static/media/lotus.ff29bd6d.svg";